import React, { ReactNode } from 'react';
import { useTheme } from 'styled-components';
import { ErrorBoundary } from '@sparknz/journeys-common';
import {
  ActionTitle,
  Box,
  Drawer,
  IconButton,
} from '@sparknz/spark-pattern-library';

import { ActionLayerErrorScreen } from 'shared/components';
import { useWearableDevice } from '../../hooks';

interface PrimaryActionLayerProps {
  children: ReactNode;
  onClose: () => void;
  title: string;
  isOpen: boolean;
}

const PrimaryActionLayer: React.FC<PrimaryActionLayerProps> = ({
  onClose,
  children,
  title,
  isOpen,
}) => {
  const { palette } = useTheme();
  const { isWearableEligibilityCheckRequired } = useWearableDevice();

  return (
    <Drawer isOpen={isOpen} onClose={onClose} showOverlay>
      <ErrorBoundary
        fallback={(props) =>
          isWearableEligibilityCheckRequired ? (
            <ActionLayerErrorScreen onDone={onClose} {...props} />
          ) : null
        }
      >
        <Box px={['s3', 's4', 's6']} pt={['s2', 's3']}>
          <Box
            alignItems="center"
            flexDirection="row"
            justifyContent="space-between"
          >
            <ActionTitle
              variant="subheadingM"
              color={palette.baseColors.newZealandBlack}
            >
              {title}
            </ActionTitle>
            <IconButton
              onClick={onClose}
              title="close"
              icon="cross_small"
              variant="secondary"
            />
          </Box>
        </Box>
        {children}
      </ErrorBoundary>
    </Drawer>
  );
};

export default PrimaryActionLayer;
